import {
  Component,
  OnInit,
} from "@angular/core";
import { TrainService } from "@core/services";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-providers",
  templateUrl: "./providers.component.html",
  styleUrls: ["./providers.component.scss"],
})
export class ProvidersComponent implements OnInit {

  constructor(
    public translate: TranslateService,
    private trainService: TrainService
  ) {}

  ngOnInit() {
    
  }

  updateTrainlineStaticData() {
    this.trainService.updateStaticData().subscribe((res) => {
    });
  }

 }
